// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_17-2";
export var blackBorderOnHover = "_17-7";
export var cell = "_17-6";
export var cellContainer = "_17-3";
export var checked = "_17-8";
export var disabled = "_17-5";
export var featuredIconCellContainer = "_17-9";
export var featuredIconTextContainer = "_17-b";
export var featuredIconWrapper = "_17-a";
export var noBorder = "_17-c";
export var orangeSelectedRow = "_3f-3";
export var overflowableText = "_17-0";
export var overflowableTextContainer = "_17-1";
export var row = "_19-0";
export var rowCheckboxCell = "_17-4";
export var selectableTable = "_3f-2";